// ─── Number formatters ─────────────────────────────────────────────────────────

export function fmtEUR(n: number, decimals = 2): string {
  return '€' + n.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export function fmtINR(n: number): string {
  return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 0 })
}

export function fmtPct(n: number, decimals = 1): string {
  return n.toFixed(decimals) + '%'
}

export function fmtNum(n: number): string {
  return n.toLocaleString('en-US')
}

export function fmtBytes(bytes: number): string {
  if (bytes < 1024) return bytes + ' B'
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
}

// ─── Date helpers ──────────────────────────────────────────────────────────────

export function fmtDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
    })
  } catch {
    return iso
  }
}

export function fmtDateTime(iso: string): string {
  try {
    return new Date(iso).toLocaleString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    })
  } catch {
    return iso
  }
}

// ─── Category helpers ──────────────────────────────────────────────────────────

export const CATEGORY_LABELS: Record<string, string> = {
  domestic:           'Domestic',
  foreign_eu:         'Foreign EU',
  foreign_noneu:      'Foreign Non-EU',
  ineligible_expense: 'Ineligible Expense',
  no_reciprocity:     'No Reciprocity',
  no_vat_mechanism:   'No VAT Mechanism',
  deadline_passed:    'Deadline Passed',
}

export const CATEGORY_TAG_CLASS: Record<string, string> = {
  domestic:           'tag-domestic',
  foreign_eu:         'tag-foreign-eu',
  foreign_noneu:      'tag-foreign-noneu',
  ineligible_expense: 'tag-ineligible',
  no_reciprocity:     'tag-no-mechanism',
  no_vat_mechanism:   'tag-no-mechanism',
  deadline_passed:    'tag-ineligible',
}

export function categoryLabel(cat: string): string {
  return CATEGORY_LABELS[cat] ?? cat.replace(/_/g, ' ')
}

export function categoryTagClass(cat: string): string {
  return CATEGORY_TAG_CLASS[cat] ?? 'tag-no-mechanism'
}

// ─── Misc ──────────────────────────────────────────────────────────────────────

export function clamp(val: number, min: number, max: number): number {
  return Math.min(Math.max(val, min), max)
}

export function barWidth(val: number, max: number): string {
  if (!max || !val) return '0%'
  return clamp((val / max) * 100, 0, 100).toFixed(1) + '%'
}
